import { cmsApiClient } from '@/config/httpClients';
import { CMSFaqItemsResponse, type CMSFaqItem } from '@/components/cms/schemas';

const getFaqsByIds = async ({
  ids,
}: {
  ids: string[];
}): Promise<CMSFaqItem[]> => {
  const response = await cmsApiClient
    .get<{
      data: CMSFaqItem[];
    }>(`collections/faqs/entries?filter[id:in]=${ids.join('|')}`)
    .json();
  if (!CMSFaqItemsResponse.safeParse(response.data).success) {
    //TODO: Log error to Sentry
    console.log(
      'CMS response validation error on getFaqsByIds',
      CMSFaqItemsResponse.safeParse(response.data).error
    );
  }
  return response.data;
};

export { getFaqsByIds };
